import { render } from "./formList.vue?vue&type=template&id=5123aa43"
import script from "./formList.vue?vue&type=script&lang=js"
export * from "./formList.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/form/formList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5123aa43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5123aa43', __exports__)) {
    console.log('reload')
    api.reload('5123aa43', __exports__)
  }
  
  module.hot.accept("./formList.vue?vue&type=template&id=5123aa43", () => {
    console.log('re-render')
    api.rerender('5123aa43', render)
  })

}


export default __exports__